import { t } from 'i18next';

export const calculateSimilarDiscountAlertTitle = (title: string | null) => {
  return (
    title === t('alert.DISCOUNT.similar.title') ||
    title === t('alert.BONUS.similar.title') ||
    title === t('alert.SHOW_AT_LOCATION.similar.title')
  );
};
